import React from 'react';
import { ClockIcon, DollarSignIcon, HeartIcon, SmileIcon } from 'lucide-react';
const ProblemSolution = () => {
  return <div className="w-full bg-white py-10 md:py-16" data-id="element-268">
      <div className="container mx-auto px-4" data-id="element-269">
        <div className="max-w-3xl mx-auto text-center mb-6 md:mb-8" data-id="element-270">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-3 md:mb-4" data-id="element-271">
            ¿Cansada de preguntarte "¿Qué voy a cocinar hoy?" todos los días?
          </h2>
          <p className="text-lg text-gray-700 mb-3 md:mb-4" data-id="element-272">
            Sabemos lo que es sentir esa frustración diaria: son las 5 de la
            tarde, los niños tienen hambre, no hay plan para la cena, y terminas
            gastando en comida rápida o improvisando algo que no satisface a
            nadie.
          </p>
          <p className="text-xl font-medium text-[#438A52] mb-4 md:mb-6" data-id="element-273">
            <strong data-id="element-274">La buena noticia:</strong> Existe una solución que ya ha
            ayudado a cientos de mamás latinas como tú.
          </p>
        </div>
        <div className="grid grid-cols-2 gap-3 md:grid-cols-4 md:gap-8 max-w-4xl mx-auto" data-id="element-275">
          <div className="bg-[#DEEFE1] p-3 md:p-6 rounded-lg text-center" data-id="element-276">
            <div className="bg-[#FAFFFB] w-12 h-12 md:w-16 md:h-16 mx-auto rounded-full flex items-center justify-center mb-2 md:mb-4" data-id="element-277">
              <ClockIcon className="w-6 h-6 md:w-8 md:h-8 text-[#438A52]" data-id="element-278" />
            </div>
            <h3 className="font-bold text-base md:text-lg mb-1 md:mb-2" data-id="element-279">
              Ahorra Tiempo
            </h3>
            <p className="text-sm md:text-base" data-id="element-280">
              Recetas listas en 30 minutos o menos
            </p>
          </div>
          <div className="bg-[#DEEFE1] p-3 md:p-6 rounded-lg text-center" data-id="element-281">
            <div className="bg-[#FAFFFB] w-12 h-12 md:w-16 md:h-16 mx-auto rounded-full flex items-center justify-center mb-2 md:mb-4" data-id="element-282">
              <DollarSignIcon className="w-6 h-6 md:w-8 md:h-8 text-[#438A52]" data-id="element-283" />
            </div>
            <h3 className="font-bold text-base md:text-lg mb-1 md:mb-2" data-id="element-284">
              Ahorra Dinero
            </h3>
            <p className="text-sm md:text-base" data-id="element-285">Menús por menos de $5 al día</p>
          </div>
          <div className="bg-[#DEEFE1] p-3 md:p-6 rounded-lg text-center" data-id="element-286">
            <div className="bg-[#FAFFFB] w-12 h-12 md:w-16 md:h-16 mx-auto rounded-full flex items-center justify-center mb-2 md:mb-4" data-id="element-287">
              <HeartIcon className="w-6 h-6 md:w-8 md:h-8 text-[#438A52]" data-id="element-288" />
            </div>
            <h3 className="font-bold text-base md:text-lg mb-1 md:mb-2" data-id="element-289">
              Alimenta Mejor
            </h3>
            <p className="text-sm md:text-base" data-id="element-290">
              Comidas nutritivas para toda la familia
            </p>
          </div>
          <div className="bg-[#DEEFE1] p-3 md:p-6 rounded-lg text-center" data-id="element-291">
            <div className="bg-[#FAFFFB] w-12 h-12 md:w-16 md:h-16 mx-auto rounded-full flex items-center justify-center mb-2 md:mb-4" data-id="element-292">
              <SmileIcon className="w-6 h-6 md:w-8 md:h-8 text-[#438A52]" data-id="element-293" />
            </div>
            <h3 className="font-bold text-base md:text-lg mb-1 md:mb-2" data-id="element-294">
              Reduce el Estrés
            </h3>
            <p className="text-sm md:text-base" data-id="element-295">
              Elimina la ansiedad de improvisar
            </p>
          </div>
        </div>
      </div>
    </div>;
};
export default ProblemSolution;